import { app } from "../../Frame/App";

export class FlexFooterDoubleCell {
    private sum: number;

    public constructor(protected cell: HTMLElement, protected field: string, protected decimals: number) {
        cell.className += " text-right justify-content-end";
    }

    public initCalc(): void {
        this.sum = 0;
    }

    public addValue(model: any): void {
        this.sum += app.anyToFloat(model[this.field]);
    }

    public updateCell(): void {
        (this.cell.firstElementChild as HTMLElement).innerText = app.formatDecimalNumber(this.sum, undefined, this.decimals);
    }
}